import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';


import { ParcelData } from '../parcelData';
import { Data } from '../variables';
import { GetDataService } from '../services/get-data.service';

import { Languages } from '../languages';
import { langEN, langSK } from '../variables';


import { filter } from 'rxjs/operators';
import { ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-show-status',
  templateUrl: './show-status.component.html',
  styleUrls: ['./show-status.component.css']
})

export class ShowStatusComponent implements OnInit, OnChanges   {

  udaje: ParcelData[] = [];

  params: ParamMap;

  wrongInput: string;

  lang: Languages;


  @Input() item: string;
  @Input() langToChild: Languages;


  constructor(private getDataService: GetDataService,
              private activatedRoute: ActivatedRoute) { }

  ngOnChanges(changes:SimpleChanges ) {

    // this.wrongInput = ''
    this.getData(this.item)

    // console.log(this.langToChild);
    this.lang = this.langToChild

  }

  ngOnInit(): void {

    var a: string

    this.lang = this.langToChild

    // aby precitalo ak niekto zada napriamo get query /?parcelId=21032600003
    this.activatedRoute.queryParams
    .pipe(filter(params => params.parcelId))
    .subscribe(params => {

      if (params.lang =='en') {
        this.lang = langEN
      } else {
        this.lang = langSK
      }

      a = params.parcelId;
      if (this.getDataService.checkIfNumber(a)) {
        this.getData(a)
      } else {    
        this.wrongInput = this.lang.badInput
      }
    });
  }

  getData(vstup: string): void {

    this.getDataService.getDataFromDB(vstup).subscribe(data => {
      this.udaje = data as ParcelData[] ;
      // console.log(data)
    });
    // if (this.udaje) this.wrongInput = 'Zásielka sa nenašla...';

  }

}
